import React from "react";
import { Layout, Modal, Tooltip, Button } from "antd";
import WorkDiaries from "../../employeeWorkDiaries";
import { CloseOutlined } from "@ant-design/icons";
import { useMedia } from "react-media";
import EmployeeDetails from "../../employeeScheduling/components/EmployeeDetails";
import { useSelector } from "react-redux";

const GLOBAL_MEDIA_QUERIES = {
  small: "(max-width: 899px)",
};

const DiariesModal = (props) => {
  const { visible, onHide } = props;
  const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });
  const activeEmployee = useSelector(
    (state) => state.employeeDetails.activeEmployee
  );
  const closeModal = () => {
    onHide();
  };

  return (
    <Modal
      width={"vw"}
      style={{
        height: "100vh",
        maxWidth: "100vw",
        position: "absolute",
        top: 0,
        left: 0,
      }}
      styles={{
        body: {
          height: "100vh",
          width: "100vw",
          padding: "10px",
        },
      }}
      className={"no-padding no-border-radius"}
      closable={false}
      open={visible}
      footer={null}
      destroyOnClose={true}
    >
      <Layout style={{ background: "transparent", paddingTop: "20px" }}>
        {matches.small ? null : (
          <div style={{ position: "absolute", left: "10px", top: "10px" }}>
            <EmployeeDetails record={activeEmployee} />
          </div>
        )}
        <Tooltip title="close">
          <Button
            onClick={closeModal}
            size="large"
            style={{ position: "absolute", right: 10, top: 10 }}
            shape="circle"
            icon={<CloseOutlined />}
          />
        </Tooltip>
        <WorkDiaries type="modal" />
      </Layout>
    </Modal>
  );
};

export default DiariesModal;
